import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { WorkflowContextService } from 'src/app/services';
import { WorkflowJanusService } from '../workflow-janus.service';

@Component({
  selector: 'wm-new-workflow-dialog',
  templateUrl: './new-workflow-dialog.component.html',
  styleUrls: ['./new-workflow-dialog.component.scss'],
  standalone: false
})
export class NewWorkflowDialogComponent {
  context: WorkflowContextService;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { context: WorkflowContextService },
    private dialogRef: MatDialogRef<NewWorkflowDialogComponent>,
    private router: Router,
    private workflowJanusService: WorkflowJanusService
  ) {
      this.context = data.context;
    }

  // Start Code added by Sanchit on 05/05/2026
  modalData = {
    open: false,
    modalDescp: 'New Workflow',
    closeBtn: false, // only close button needed
    modalWidth: 'auto',
    modalHeight: 'auto'
  };

  openModal() {
    this.modalData.open = true;
  }

  closeModal() {
    this.modalData.open = false;
  }
  openBlank() {
    this.close();
    this.workflowJanusService.setNewWorkflowButtonDisabled(true);

    const segments = this.router.routerState.snapshot.url
      .split('/')
      .filter(Boolean);

    this.router.navigate([
      '/',
      ...segments,
      { outlets: { editWorkflow: ['new', 'blank'] } }
    ]);
  }

  openTemplate() {
    this.close();
    this.workflowJanusService.setNewWorkflowButtonDisabled(true);

    const segments = this.router.routerState.snapshot.url
      .split('/')
      .filter(Boolean);

    this.router.navigate([
      '/',
      ...segments,
      { outlets: { modal: ['new', 'template'] } }
    ]);
  }

  ngOnInit() {
    this.modalData.open = true;
  }
  // End Code added by Sanchit on 05/05/2026

  close(): void {
    this.workflowJanusService.setNewWorkflowButtonDisabled(false);
    this.dialogRef.close();
  }

  // createBlank(): void {
  //   this.dialogRef.close({ action: 'blank' });
  // }

  // useTemplate(): void {
  //   this.dialogRef.close({ action: 'template' });
  // }

  // openBlank() {
  //   this.dialogRef.close();
  //   const parentRoute = this.router.routerState.snapshot.url;
  //   const segments = parentRoute.split('/').filter(Boolean);

  //   this.router.navigate(
  //     [
  //       '/',
  //       ...segments,
  //       { outlets: { editWorkflow: ['new', 'blank'] } }],
  //   )


  //   // this.router.navigate(
  //   //   [
  //   //     '/',
  //   //     ...segments,
  //   //     { outlets: { modal: ['new', 'blank'] } }],
  //   // )
  // }

  // openTemplate() {
  //   this.dialogRef.close();
  //   const parentRoute = this.router.routerState.snapshot.url;
  //   const segments = parentRoute.split('/').filter(Boolean);

  //   this.router.navigate(
  //     [
  //       '/',
  //       ...segments,
  //       { outlets: { modal: ['new', 'template'] } }],
  //   )
  //   // this.router.navigate(
  //   //   [{ outlets: { modal: ['new', 'template'] } }],
  //   //   { relativeTo: this.route?.parent }
  //   // )
  // }
}
